import React, {useState} from 'react';
import '../css/dataTable.css';
import { serviceUsers } from '../Data/serviceUser.js';
import { useTable } from "../hooks/useTable";
import { FaFileCsv, FaFilePdf, FaFileExcel } from 'react-icons/fa';
import { exportToCSV, exportToPDF, exportToExcel } from '../../utils/exportUtils.js';
import { BiTrash } from "react-icons/bi"; 
import { BiEditAlt } from "react-icons/bi"; 
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import EditServiceForm from '../forms/edits/EditServiceForm.jsx';
import ServiceForm from '../forms/ServiceForm.jsx';

function ServiceTable() {const [showModal, setShowModal] = useState(false);
      const [showEditModal, setShowEditModal] = useState(false);
      const [selectedService, setSelectedService] = useState({});


    const [searchTerm, setSearchTerm] = useState("");
        const itemsPerPage = 5;
        
        const { currentItems, filteredData, currentPage, paginate } = useTable(
            serviceUsers,
            itemsPerPage,
            searchTerm
          );
    
        // Définir les en-têtes pour le PDF
        const headers = ['Nom institution', 'Adresse', 'Email', 'Téléphone','type Intitution',  'gerant', 'Poste', 'Statut'];
    
        const handleAddAdmin = () => {
            alert("ok");
        };

        const handleAddNew = () => {
                setShowModal(true);
              };
            
              const handleCloseModal = () => {
                setShowModal(false);
              };
            
              const handleEditService = (categorie) => {
                setSelectedService(categorie);
                setShowEditModal(true);
              };
            
              const handleCloseEditModal = () => {
                setShowEditModal(false);
              };
            
             const handleUpdateService = (updatedService) => {
                 const updatedList = serviceUsers.map((service) => {
                   if (service.nomComplet === selectedService.nomComplet) {
                     return updatedService;
                   }
                   return service;
                 });
             
                 setShowEditModal(false);
               };

               const handleDeleteService = (service) => {
                       if (window.confirm(`Voulez-vous vraiment supprimer la service ${service.name} ?`)) {
                         
                         toast.success(`La service ${service.name} a été supprimé avec succès !`);
                       }
                     };
  return (
    <div className="container">
        {/* En-tête avec titre et barre de recherche */}
        <div className="header-container">
          <h2 className="table-title">Liste des services / institutions</h2>
          <input
            type="text"
            placeholder="Rechercher une institution ou service..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-bar"
          />
        </div>
    
        {/* Boutons d'exportation */}
        <div className="export-buttons-container">
                    <button onClick={() => exportToCSV(filteredData, 'institution')} className="export-button">
                        <FaFileCsv className="icon" /> Export CSV
                    </button>
                    <button onClick={() => exportToPDF(filteredData, headers, 'institution')} className="export-button">
                        <FaFilePdf className="icon" /> Export PDF
                    </button>
                    <button onClick={() => exportToExcel(filteredData, 'institution')} className="export-button">
                        <FaFileExcel className="icon" /> Export Excel
                    </button>
                    <button onClick={handleAddNew} className="add-admin-button">
                        Ajouter un service
                    </button>
                </div>
    
        {/* Tableau */}
        <table className="abonne-table">
          <thead>
            <tr>
              <th>Nom institution</th>
              <th>Adresse</th>
              <th>telephone</th>
              <th>Categorie</th>
              <th>Status</th>
              <th>Opération</th>
            </tr>
          </thead>
          <tbody>
            {currentItems.map((service) => (
              <tr key={service.id}>
                    <td>{service.nomInstitution}</td>
                    <td>{service.adresseInstitution}</td>
                    <td>{service.telephone}</td>
                    <td>{service.typeIntitution}</td>
                    <td>{service.Etat}</td>
                    <td className="border border-gray-300 px-4 py-2">
                                    <button className="text-blue-500 mx-1" onClick={() =>  handleEditService(service)}><BiEditAlt /></button>
                                    <button className="text-red-500 mx-1" onClick={() => handleDeleteService(service)}><BiTrash /></button>
                                  </td>
                </tr>
            ))}
          </tbody>
        </table>
    
        {/* Pagination */}
        <div className="pagination">
          {Array.from(
            { length: Math.ceil(filteredData.length / itemsPerPage) },
            (_, i) => (
              <button
                key={i + 1}
                onClick={() => paginate(i + 1)}
                className={currentPage === i + 1 ? "active" : ""}
              >
                {i + 1}
              </button>
            )
          )}
        </div>

        {showModal && (
        <div className="modal">
          <div className="modal-content">
            <button className="close-button" onClick={handleCloseModal}>
              &times;
            </button>
            <ServiceForm />
          </div>
        </div>
      )}


      {showEditModal && (
        <div className="modal">
          <div className="modal-content">
            <button className="close-button" onClick={handleCloseEditModal}>
              &times;
            </button>
            <EditServiceForm service={selectedService} handleUpdateService={handleUpdateService}/>
          </div>
        </div>
      )}
      </div>
  )
}

export default ServiceTable